import React, { useState } from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/common/Layout'
import { default as BlueprintsGrid } from '../components/blueprints/Grid'
import PageHeader from '../components/help/PageHeader'
import Grid from '../components/help/Grid'
import Container from '../components/common/Container'

const GuidesPage = ({ data }) => {
  const allGuides = data.markdownGuides.nodes.map(node => ({
    _id: node.id,
    slug: { current: node.frontmatter.slug },
    title: node.frontmatter.title,
    description: node.frontmatter.description,
    topic: node.frontmatter.topic,
  }))
  const allCourses = data.markdownCourses.nodes.map(node => ({
    id: node.id,
    slug: { current: node.frontmatter.slug },
    title: node.frontmatter.title,
    description: node.frontmatter.description,
    featuredImage: {
      asset: {
        url: node.frontmatter.featuredImage
      }
    },
    level: node.frontmatter.level,
    longDescription: node.frontmatter.longDescription,
    lessons: []
  }))
  const spotlight = allCourses ? allCourses[0] : null
  const blueprints = data.markdownBlueprints.nodes.map(node => ({
    id: node.id,
    slug: { current: node.frontmatter.slug },
    title: node.frontmatter.title,
    useCase: node.frontmatter.useCase,
    featuredImage: {
      asset: {
        url: node.frontmatter.featuredImage
      }
    },
  }))

  return (
    <Layout
      title="Atlas Guides - Learn how to use Atlas"
      meta={{
        description:
          'Start with the basics, or explore advanced features to become an Atlas expert. Learn how to use Atlas to create beautiful maps and visualizations.',
        title: 'Atlas Guides - Learn how to use Atlas',
        type: 'website',
        absoluteImageUrl: 'https://atlas.co/images/guides-og.png'
      }}
    >
      <main>
        <PageHeader
          title="Guides"
          subtitle="Access our community’s best resources to build powerful maps
              leveraging the full-power of Atlas and other tools"
        />
        <Grid data={allGuides} spotlight={spotlight} />
        <Container>
          <div style={{ maxWidth: '600px' }}>
            <h2>Ready for some hands-on walkthroughs?</h2>
            <p>
              Check out our Atlas Blueprints with step-by-step walkthroughs to
              help you build powerful maps and visualizations.
            </p>
          </div>
          <BlueprintsGrid data={blueprints.slice(0, 3)} />
        </Container>
      </main>
    </Layout>
  )
}

export default GuidesPage

export const query = graphql`
  query {
    markdownGuides: allMarkdownRemark(
      filter: { 
        fileAbsolutePath: { regex: "/guides/" }
        frontmatter: { template: { eq: "SingleGuide" } }
      }
    ) {
      nodes {
        id
        frontmatter {
          title
          slug
          description
          topic
        }
      }
    }
    markdownCourses: allMarkdownRemark(
      filter: { 
        fileAbsolutePath: { regex: "/academy/" }
        frontmatter: { template: { eq: "CoursePage" } }
      }
    ) {
      nodes {
        id
        frontmatter {
          title
          slug
          description
          featuredImage
          level
          longDescription
        }
      }
    }
    markdownBlueprints: allMarkdownRemark(
      filter: { 
        fileAbsolutePath: { regex: "/blueprints/" }
        frontmatter: { template: { eq: "SingleBlueprint" } }
      }
    ) {
      nodes {
        id
        frontmatter {
          title
          slug
          useCase
          featuredImage
        }
      }
    }
  }
`
